export const COB_ADDITIONAL_SET_ANSWER = "COB_ADDITIONAL_SET_ANSWER";
export const COB_ADDITIONAL_LOAD_ANSWERS = "COB_ADDITIONAL_LOAD_ANSWERS";
export const COB_ADDITIONAL_COMPONENT_COMPLETE =
  "COB_ADDITIONAL_COMPONENT_COMPLETE";
export const COB_ADDITIONAL_SET_FILE = "COB_ADDITIONAL_SET_FILE";
